export default Object.freeze({
    CHART_OF_ACCOUNT: 'chart_of_accounts',
    JOURNAL_TEMPLATE: 'journal_template',
    DOCUMENT_TOKENS_LIST: 'document_tokens_list',
    PRICING_TABLE_INSTRUCTIONS: 'pricing_table_instructions',
    DNR_SAMPLE_SHEET: 'dnr_sample_sheet',
    DNR_SHEET_GUIDE: 'dnr_sheet_guide',
    WALK_THROUGH_ORDER: 'walk_through_order_sheet',
});